// components/Tips/TipContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useClient, useUserContext, useOrganisationContext } from "../../hooks";
const TipContext = createContext();

export const TipProvider = ({ children }) => {
    const [completedTips, setCompletedTips] = useState({});
    const [activeTip, setActiveTip] = useState(null);
    const [hideTips, setHideTips] = useState(false);

    const { user } = useUserContext();
    const { selectedOrganisation } = useOrganisationContext();
    const client = useClient();

    useEffect(() => {
        if (!selectedOrganisation) return
        
        // Load completed tips from localStorage
        const stored = localStorage.getItem('completedTips');
        if (stored) {
            setCompletedTips(JSON.parse(stored));
        }

        if ((user?.groups && user?.groups[0].name !== "Superadmin") || (selectedOrganisation && selectedOrganisation.status === 'LIVE')) {
            updateHideTips()
        } else {
            resetTips()
        }
    }, [selectedOrganisation]);

    const markTipComplete = (tipId) => {
        setCompletedTips(prev => {
            const updated = { ...prev, [tipId]: true };
            localStorage.setItem('completedTips', JSON.stringify(updated));
            return updated;
        });
    };

    const resetTips = () => {
        localStorage.removeItem('completedTips');
        localStorage.removeItem('hideTips');
        setCompletedTips({});

        if (user && !user.show_xero_tips) {
            updateShowXeroTipsStatus(true)
        }
    };

    const updateHideTips = () => {
        localStorage.setItem('hideTips', true);
        setActiveTip(null);
        setHideTips(true);

        if (user && user.show_xero_tips) {
            updateShowXeroTipsStatus(false)
        }
    }

    const updateShowXeroTipsStatus = async (status) => {
        await client.patch(`/me/update_me`, {
            show_xero_tips: status
        })
    }

    return (
        <TipContext.Provider value={{
            completedTips,
            markTipComplete,
            resetTips,
            activeTip,
            setActiveTip,
            hideTips,
            updateHideTips,
            updateShowXeroTipsStatus
        }}>
            {children}
        </TipContext.Provider>
    );
};

export const useTips = () => useContext(TipContext);
